
import abbreviateNum from "../../../../scripts/rebuild/abbreviate-num"

export default function() {
	function renderCryptoInfo(coin, nodesObj) {
		let url = `https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${coin}&tsyms=USD`
		fetch(url)
			.then((response) => {
				return response.json()
			})
			.then((dataJson) => {
				const displayData = dataJson.DISPLAY[coin].USD
				const rawData = dataJson.RAW[coin].USD
				const fiatChar = displayData.TOSYMBOL

				const supply = displayData.CIRCULATINGSUPPLY.split('.')[0]
				const price = +displayData.PRICE.split('.')[1] === 0 ? displayData.PRICE.split('.')[0] : displayData.PRICE
				const volume24 = `${fiatChar} ${abbreviateNum(rawData.VOLUME24HOURTO)}`
				

				nodesObj.circSupply.innerText = supply;
				nodesObj.volume24.innerText = volume24;
				nodesObj.price.innerText = price;

			}).catch(err =>{
				console.log(err)
				for( let key in nodesObj){
					nodesObj[key].innerText = "no data"
				}
			})
		
	}
	let container = document.querySelector('.crypto-info')
	let colHead = document.querySelectorAll('.crypto-info__col_head')
	colHead.forEach(function(item) {
		let coin = item.getAttribute('data-coin');
		if(coin === "USDTERC20" || coin === "USDTTRC20") {
			coin = "USDT"
		}
		let circSupply = container.querySelector(`.circ-supply[data-coin='${coin}']`)
		// let maxSupply = container.querySelector(`.max-supply[data-coin='${coin}']`)
		let volume24 = container.querySelector(`.volume-24[data-coin='${coin}']`)
		let price = container.querySelector(`.price[data-coin='${coin}']`)
		renderCryptoInfo(coin, {circSupply, volume24, price})
	})
}